import _ from 'underscore';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {RequestDetailsQuery} from 'requests/request-view/__generated/RequestDetailsQuery';

type RequestDetailsTaskGraphQL = ExtractByTypename<
  RequestDetailsQuery['request'],
  'RequestNode'
>['tasks'][number];

export interface SampleGroupIdsByRequestTaskIdMap {
  [taskCid: string]: Array<string>;
}

export default function getSampleGroupIdsByRequestTaskId(
  requestTasks: Array<RequestDetailsTaskGraphQL>
): SampleGroupIdsByRequestTaskIdMap {
  return _.object(requestTasks.map((task) => [task.id, task.sampleGroups.map((sg) => sg.id)]));
}
